module.exports = __webpack_public_path__ + "readmeTemplates/OSH_manufacturing.52981e6962836b0c1db86d35f0f3750a.md";